import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { InsideImage } from '../volkswagen.types';

@Component({
  selector: 'app-vw-image-relation',
  imports: [CommonModule],
  standalone: true,
  template: `
    <span class="hidden text-xs font-medium italic">
      (Siehe
      <strong class="px-[1px]">{{ data.text }}</strong>
      im Bild)
    </span>

    <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
  `,
})
export class InsideImageComponent extends XMLElementBaseComponent<InsideImage> {}
